import { ShieldCheck, BadgeIndianRupee, Users, TrendingUp } from "lucide-react";

const PILLARS = [
    {
        icon: ShieldCheck,
        title: "AI Lead Qualification",
        body: "AI helps assess enquiries based on location, budget and intent — OTP verification is also available as a lead-quality tier.",
    },
    {
        icon: BadgeIndianRupee,
        title: "Transparent Pricing",
        body: "No hidden charges, no lock-ins. Commercials are shared upfront and reviewed openly every quarter.",
    },
    {
        icon: Users,
        title: "Real Buyers · Real Interest",
        body: "Only serious buyers actively searching for a property in your city, price band and configuration.",
    },
    {
        icon: TrendingUp,
        title: "Higher ROI · Better Growth",
        body: "We optimise for quality over quantity — leads that convert to site visits, and site visits to bookings.",
    },
];

export default function TrustPillars() {
    return (
        <section
            id="pillars"
            data-testid="pillars-section"
            className="relative py-20 px-6 sm:px-10 lg:px-16 border-t border-white/5"
        >
            <div className="max-w-7xl mx-auto">
                <div className="flex items-center gap-3 mb-10">
                    <div className="h-px w-10 bg-[#D4AF37]" />
                    <span className="overline">Why Developers Choose Us</span>
                </div>

                <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
                    {PILLARS.map((p) => (
                        <div
                            key={p.title}
                            data-testid={`pillar-${p.title.replace(/\s/g, "-").toLowerCase()}`}
                            className="bg-[#050507] p-6 sm:p-8 group hover:bg-[#0A0B10] transition-colors"
                        >
                            <div className="h-11 w-11 grid place-items-center border border-[#D4AF37]/40 text-[#D4AF37] group-hover:bg-[#D4AF37] group-hover:text-black transition-all">
                                <p.icon size={20} strokeWidth={1.5} />
                            </div>
                            <h3 className="mt-6 font-serif-display text-xl leading-tight">{p.title}</h3>
                            <p className="mt-3 text-sm text-white/60 leading-relaxed">{p.body}</p>
                        </div>
                    ))}
                </div>

                {/* Big brand line */}
                <div className="mt-16 text-center">
                    <p className="font-serif-display text-2xl sm:text-3xl text-white/50 tracking-wide">
                        Verified Leads. <span className="text-[#D4AF37]">Serious Buyers.</span> Real Growth.
                    </p>
                </div>
            </div>
        </section>
    );
}
